

function set(state, fn) {
	if (fn)
		fn(state);
}

let setAllGlobalAddresses = (state, globalAddressesDto) => {
	state.allGlobalAddresses = globalAddressesDto;
};

function setErrors(state, errors) {
	if (!errors) return;
	state.errors.invalidName = errors.invalidName || false;
	state.errors.invalidPostalCode = errors.invalidPostalCode || false;
}

function clearErrors(state) {
	state.errors.invalidName = false;
	state.errors.invalidPostalCode = false;
}

function setLoading(state, { key, isLoading }) {
	state.loading[key] = isLoading;
}


export default {
	set,
	setAllGlobalAddresses,
	setErrors,
	clearErrors,
	setLoading,
};
